<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body">
              <div class="">
                <div class="d-flex justify-content-end align-items-end">
                  <button class="btn btn-sm btn-primary text-capitalize me-2" @click="savePriority">{{ helper.trans('button.save_order')}}</button>
                  <button type="button" @click="showEditModal()" class="btn btn-sm btn-outline-primary text-nowrap text-capitalize">{{helper.trans('button.create')}}</button>
                </div>

                <b-modal
                  :title="createModalTitle"
                  :modelValue="createModal"
                  dialog-class="modal-lg"
                  body-class="pt-0"
                  @update:modelValue="createModal = $event"
                >
                  <template #default>
                    <CascadeForm ref="createForm" :provider-rating-enabled="providerRatingEnabled"></CascadeForm>
                  </template>
                  <template #footer>
                    <button type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                    <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                      <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                    </LoaderWrapper>
                  </template>
                </b-modal>

                <div class="overflow-auto">
                  <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                    <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th>{{helper.trans('labels.id')}}</th>
                      <th>{{helper.trans('labels.title')}}</th>
                      <th>{{helper.trans('labels.settings')}}</th>
                      <th class="text-end"></th>
                    </tr>
                    </thead>
                    <Sortable
                      :list="cascades"
                      item-key="id"
                      @end="onUpdate($event)"
                      tag="tbody"
                      class=""
                      :options="{draggable: '.draggable', handle: '.drag-handle'}"
                    >
                      <template #item="{element, index}">
                        <tr class="draggable">
                          <td style="width: 0">
                            <div class="drag-handle p-3 ps-4 pe-4">
                              <i class="fa-solid fa-grip-vertical"></i>
                            </div>
                          </td>
                          <td style="width: 0">
                            <i v-if="element.direction === Direction.PAY_IN" v-b-tooltip.hover :title="helper.trans(`direction.${element.direction}`)" class="fa-regular fa-circle-down text-primary"></i>
                            <i v-else v-b-tooltip.hover :title="helper.trans(`direction.${element.direction}`)" class="fa-regular fa-circle-up text-warning"></i>
                            <i v-if="!element.enabled" class="fa fa-stop-circle text-danger ms-1"></i>
                            <i v-if="element.beforeTraderRequisites" v-b-tooltip.hover :title="helper.trans(`labels.cascadeBeforeTraderRequisites`)" class="fa fa-warning text-warning"></i>
                          </td>
                          <td style="width: 0">
                            {{element.id}}
                          </td>
                          <td style="width: 0;">
                            {{element.name}}
                            <span v-if="providerRatingEnabled" class="badge me-1" :class="getRatingBadgeClass(element)">
                              {{ helper.trans(`labels.provider_rating_badge_${getRatingBadge(element)}`) }}
                            </span>
                            <span v-if=element.isAsync> 🔀</span>
                            <span v-if=element.isBothSide> ↕️</span>
                          </td>
                          <td>
                            <span class="badge bg-primary me-1" v-if="element.config.currency">{{element.config.currency}}</span>
                            <span class="badge bg-primary me-1" v-if="element.config.minSum">
                              {{helper.trans('labels.from_limit', {sum: numberFormatter.formatMoney(element.config.minSum), currency: ''})}}
                            </span>
                            <span class="badge bg-primary me-1" v-if="element.config.maxSum">
                              {{helper.trans('labels.to_limit', {sum: numberFormatter.formatMoney(element.config.maxSum), currency: ''})}}
                            </span>
                            <span v-for="option in element.config.paymentOptions" class="badge bg-primary me-1">
                              {{ helper.trans('payment_options.' + option) }}
                            </span>
                            <span v-for="method in element.config.paymentMethods" class="badge bg-primary me-1">
                              {{ helper.trans('pay_methods.' + method) }}
                            </span>
                          </td>
                          <td class="text-end">
                            <div class="d-flex justify-content-end gap-2">
                              <button type="button" @click="showEditModal(element)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                              <button type="button" @click="showDeleteModal(element)" class="btn btn-sm btn-outline-danger text-nowrap text-capitalize"><i class="fa fa-trash"></i> {{helper.trans('button.delete')}}</button>
                            </div>
                          </td>
                        </tr>


                      </template>
                    </Sortable>
                  </table>
                </div>
                <ConfirmModal ref="confirmModal"></ConfirmModal>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import {Sortable} from "sortablejs-vue3";
import {Direction} from "@/models/enum/Direction";
import CascadeDTO from "@/models/CascadeDTO";
import CascadeForm from "@/components/Form/CascadeForm.vue";
import CascadeFormDTO from "@/models/form/CascadeFormDTO";
import PaginationDTO from "@/models/PaginationDTO";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import ConfirmModal from "@/components/ConfirmModal.vue";

const notification = useNotification()
const defaultForm = {
  id: null,
  name: null,
  enabled: false,
  beforeTraderRequisites: false,
  direction: Direction.PAY_IN,
  paymentOptions: [],
  paymentMethods: [],
  currency: null,
  minAmount: null,
  maxAmount: null,
  providers: [],
  stores: [],
  isAsync: false,
  ratingType: null,
  ratingA: null,
  ratingB: null,
  ratingC: null,
} as CascadeFormDTO

export default defineComponent({
  components: {
    CascadeForm,
    LoaderWrapper,
    Sortable,
    ConfirmModal
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const createForm = ref<InstanceType<typeof CascadeForm> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    const state = reactive({
      createModalTitle: '',
      createModal: false,
      cascades: [] as CascadeDTO[],
    });

    const providerRatingEnabled = computed(() => !!store.getters.getAppData?.providerRatingEnabled)
    const providerRatingApply = computed(() => !!store.getters.getAppData?.providerRatingApply)

    const getRatingBadge = (cascade: CascadeDTO) => {
      if (!providerRatingEnabled.value || cascade.isAsync || !cascade.ratingType) return 'manual'
      return providerRatingApply.value ? 'auto' : 'shadow'
    }

    const ratingBadgeClasses: Record<string, string> = {
      manual: 'bg-secondary',
      shadow: 'bg-info',
      auto: 'bg-success',
    }

    const getRatingBadgeClass = (cascade: CascadeDTO) => ratingBadgeClasses[getRatingBadge(cascade)]

    const loadList = async () => {
      loader.value?.show()
      try {
        state.cascades = await api.call.cascades.all()
      } finally {
        loader.value?.hide()
      }
    }

    const savePriority = async () => {
      loader.value?.show()


      try {
        await api.call.cascades.updatePriorities(state.cascades.map((cascade) => cascade.id))
        loadList()
      } catch (e) {
        loader.value?.hide()
      }
    }

    const save = async () => {
      loaderCreateFrom.value?.show()

      createForm.value!.save()
        .then(() => {
          state.createModal = false;
          loadList();
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })
    }

    function onUpdate(event: any): void {
      if (!event.oldIndex && !event.newIndex) {
        return;
      }

      if (event.newIndex == event.oldIndex) {
        return;
      }

      let cascades = []
      const item = state.cascades[event.oldIndex]
      for (const index in state.cascades) {
        if (index == event.oldIndex) {
            continue;
        }

        if (index == event.newIndex && event.newIndex < event.oldIndex) {
          cascades.push(item)
        }
        cascades.push(state.cascades[index])
        if (index == event.newIndex && event.newIndex > event.oldIndex) {
          cascades.push(item)
        }
      }

      state.cascades = cascades

    }

    const showEditModal = async (dto: CascadeDTO|null = null) => {
      if (dto) {
        const providers = await api.call.cascades.providers(dto.id)
        let stores =[]  as MerchantStoreDTO[]
        if (dto.config.storeIds) {
          stores = (await api.merchantStores({offset: 0, limit: dto.config.storeIds.length} as PaginationDTO, {ids: dto.config.storeIds})).items
        }

        state.createModalTitle = helper.trans("labels.edit_cascade", {name: dto.name})
        createForm.value?.setForm({
          ...defaultForm,
          ...dto,
          ...dto.config,
          minAmount: dto.config.minSum?.amount,
          maxAmount: dto.config.maxSum?.amount,
          stores,
          providers,
        } as CascadeFormDTO)
      } else {
        state.createModalTitle = helper.trans("labels.create_cascade")
        createForm.value?.setForm({...defaultForm} as CascadeFormDTO)
      }

      state.createModal = true;
    }

    const showDeleteModal = async (dto: CascadeDTO | null = null) => {
      if (!dto) {
        return;
      }

      confirmModal.value?.show({
        title: helper.trans('messages.confirm_delete_cascade', {name: dto.name}),
        okTitle: helper.trans('button.delete'),
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.call.cascades.delete(dto.id)

            notification.notify({
              type: 'success',
              title: helper.trans('success'),
              text: helper.trans('success.cascade_deleted')
            })

            loadList()
          } catch (error: any) {
            notification.notify({
              type: 'error',
              title: helper.trans('error'),
              text: helper.trans('error.unable_to_delete_cascade')
            })
          }
        }
      });
    }

    onMounted(async () => {
      loadList()
    });

    return {
      ...toRefs(state),
      createForm,
      loaderCreateFrom,
      store,
      loader,
      dateHelper,
      numberFormatter,
      helper,
      confirmModal,
      save,
      savePriority,
      loadList,
      Direction,
      onUpdate,
      showEditModal,
      showDeleteModal,
      getRatingBadge,
      getRatingBadgeClass,
      providerRatingEnabled,
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
    }
  }
})
</script>
